import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { fieldsToRecalculate } from '../constants'

import { getRecalculatedOther } from './getRecalculatedOther'
import { getRecalculatedSellThruAndFYFieldsForOthers } from './getRecalculatedSellThruAndFYFieldsForOthers'

export const getRecalculatedOthersForAllFields = (competitors: ISobCompetitor[]) => {
  return fieldsToRecalculate.reduce((accCompetitors, field) => {
    const updatedOthers = getRecalculatedOther({ competitors: accCompetitors, field })

    return getRecalculatedSellThruAndFYFieldsForOthers({
      competitors: updatedOthers,
      field: field,
    })
  }, competitors)
}
